module.exports = __webpack_public_path__ + "static/media/castelino.95a17e75.jpg";